(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('site-header');
    var toggle = document.getElementById('menu-toggle');
    if (!header || !toggle) return;

    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    });

    document.addEventListener('click', function (e) {
      if (header.classList.contains('is-menu-open') && !header.contains(e.target)) {
        header.classList.remove('is-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Menü öffnen');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petalith-konfigurator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('konfig-form');
    if (!form) return;

    var variantsEl = document.getElementById('konfig-variants-json');
    if (!variantsEl) return;

    var variants    = JSON.parse(variantsEl.textContent);
    var variantId   = document.getElementById('konfig-variant-id');
    var priceEl     = document.getElementById('konfig-price');
    var submitBtn   = document.getElementById('konfig-submit');
    var agbInput    = document.getElementById('konfig-agb');
    var fileInput   = document.getElementById('konfig-file');
    var dropzone    = document.getElementById('konfig-dropzone');
    var uploadText  = document.getElementById('konfig-upload-text');
    var uploadError = document.getElementById('konfig-upload-error');
    var laterInput  = document.getElementById('konfig-photo-later');
    var laterProp   = document.getElementById('konfig-photo-later-prop');
    var laterNote   = document.getElementById('konfig-later-note');
    var uploadNow   = document.getElementById('konfig-upload-now');
    var klarnaRate  = document.getElementById('konfig-klarna-rate');

    var MAX_BYTES = 20 * 1024 * 1024; // Shopify-Limit für native Datei-Uploads
    var DEFAULT_UPLOAD_TEXT = uploadText ? uploadText.textContent : 'Foto auswählen oder hier ablegen';

    function getChecked(name) {
      var el = form.querySelector('[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function showUploadError(msg) {
      if (!uploadError) return;
      if (msg) {
        uploadError.textContent = msg;
        uploadError.hidden = false;
      } else {
        uploadError.textContent = '';
        uploadError.hidden = true;
      }
    }

    function clearFile() {
      if (fileInput) {
        try { fileInput.value = ''; } catch (e) {}
      }
      if (dropzone) dropzone.classList.remove('has-file');
      if (uploadText) uploadText.textContent = DEFAULT_UPLOAD_TEXT;
    }

    function validateFile() {
      if (!fileInput || !fileInput.files || !fileInput.files.length) {
        return false;
      }
      var file = fileInput.files[0];
      if (file.type && file.type.indexOf('image/') !== 0) {
        showUploadError('Bitte ein Bild hochladen (JPG, PNG, TIFF oder WebP).');
        clearFile();
        return false;
      }
      if (file.size > MAX_BYTES) {
        showUploadError('Die Datei ist zu groß (max. 20 MB). Bitte etwas kleiner exportieren.');
        clearFile();
        return false;
      }
      showUploadError('');
      if (dropzone) dropzone.classList.add('has-file');
      if (uploadText) uploadText.textContent = file.name;
      return true;
    }

    function uploadLater() {
      return !!(laterInput && laterInput.checked);
    }

    function photoOk() {
      // Foto ist optional: ok, wenn "später nachreichen" gewählt ist ODER ein Foto vorliegt
      if (uploadLater()) return true;
      return !!(fileInput && fileInput.files && fileInput.files.length);
    }

    function syncLater() {
      var later = uploadLater();
      if (uploadNow) uploadNow.hidden = later;
      if (laterNote) laterNote.hidden = !later;
      // "später"-Property nur mitschicken, wenn aktiv (sonst trägt die Foto-1-Datei die Info)
      if (laterProp) laterProp.disabled = !later;
    }

    function findVariant(size, mount) {
      return variants.find(function (v) {
        return v.option1 === size && v.option2 === mount;
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }

    function syncSelectedClasses() {
      var size  = getChecked('konfig-size');
      var mount = getChecked('konfig-mount');

      form.querySelectorAll('.konfig__size-card').forEach(function (card) {
        card.classList.toggle('is-selected', card.dataset.size === size);
      });

      form.querySelectorAll('.konfig__mount-option').forEach(function (opt) {
        var radio = opt.querySelector('.konfig__mount-radio');
        opt.classList.toggle('is-selected', radio && radio.value === mount);
      });
    }

    function updateSubmit(variant) {
      var available = variant && variant.available;
      var agbOk     = agbInput && agbInput.checked;

      submitBtn.disabled     = !available || !agbOk || !photoOk();
      submitBtn.textContent  = available ? 'In den Warenkorb legen' : 'Nicht verfügbar';
    }

    function handleOptionChange() {
      var size    = getChecked('konfig-size');
      var mount   = getChecked('konfig-mount');
      var variant = (size && mount) ? findVariant(size, mount) : null;

      syncSelectedClasses();

      if (variant) {
        variantId.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (klarnaRate) klarnaRate.textContent = formatMoney(Math.round(variant.price / 3));
      }

      updateSubmit(variant);
    }

    function refreshSubmit() {
      var size    = getChecked('konfig-size');
      var mount   = getChecked('konfig-mount');
      updateSubmit((size && mount) ? findVariant(size, mount) : null);
    }

    form.addEventListener('change', function (e) {
      var n = e.target.name;
      if (n === 'konfig-size' || n === 'konfig-mount') {
        handleOptionChange();
        return;
      }
      if (e.target.id === 'konfig-file') {
        validateFile();
        refreshSubmit();
        return;
      }
      if (e.target.id === 'konfig-photo-later') {
        syncLater();
        showUploadError('');
        refreshSubmit();
        return;
      }
      if (e.target.id === 'konfig-agb') {
        refreshSubmit();
      }
    });

    if (dropzone && fileInput) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'dragend', 'drop'].forEach(function (ev) {
        dropzone.addEventListener(ev, function () {
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          fileInput.files = e.dataTransfer.files;
          validateFile();
          refreshSubmit();
        }
      });
    }

    form.addEventListener('submit', function (e) {
      if (!photoOk()) {
        e.preventDefault();
        showUploadError('Bitte lade ein Foto hoch oder aktiviere „Foto später nachreichen".');
        if (dropzone && dropzone.scrollIntoView) {
          dropzone.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    // Optionale Zusatzfotos: Validierung + Dateiname anzeigen
    function wireExtraFile(id) {
      var input = document.getElementById(id);
      if (!input) return;
      var labelEl = input.parentNode.querySelector('.konfig__file-row-label');
      var rowEl   = input.closest('.konfig__file-row');
      var def     = labelEl ? labelEl.getAttribute('data-default') : '';

      input.addEventListener('change', function () {
        if (!input.files || !input.files.length) {
          if (labelEl) labelEl.textContent = def;
          if (rowEl) rowEl.classList.remove('has-file');
          return;
        }
        var file = input.files[0];
        var typeOk = !file.type || file.type.indexOf('image/') === 0;
        if (!typeOk || file.size > MAX_BYTES) {
          try { input.value = ''; } catch (e) {}
          if (labelEl) labelEl.textContent = def;
          if (rowEl) rowEl.classList.remove('has-file');
          showUploadError(!typeOk
            ? 'Bitte ein Bild hochladen (JPG, PNG, TIFF oder WebP).'
            : 'Die Datei ist zu groß (max. 20 MB).');
          return;
        }
        showUploadError('');
        if (labelEl) labelEl.textContent = '✓ ' + file.name;
        if (rowEl) rowEl.classList.add('has-file');
      });
    }
    wireExtraFile('konfig-file-2');
    wireExtraFile('konfig-file-3');

    // Zeichenzähler Personalisierung
    var personalInput = document.getElementById('konfig-personalization');
    var charCount     = document.getElementById('konfig-char-count');
    if (personalInput && charCount) {
      var updateCount = function () {
        charCount.textContent = personalInput.value.length;
      };
      personalInput.addEventListener('input', updateCount);
      updateCount();
    }

    // Galerie: Slide per Thumbnail wechseln (Bilder + Video)
    var slides = document.querySelectorAll('.konfig__slide');
    var thumbs = document.querySelectorAll('.konfig__thumb');
    if (slides.length && thumbs.length) {
      function activateMedia(id) {
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-media-id') === id;
          slide.classList.toggle('is-active', active);
          var video = slide.querySelector('video');
          if (video) {
            if (active) {
              var p = video.play();
              if (p && p.catch) { p.catch(function () {}); }
            } else {
              try { video.pause(); } catch (e) {}
            }
          }
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') === id);
        });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateMedia(thumb.getAttribute('data-media-id'));
        });
      });
    }

    syncLater();
    handleOptionChange();
  })();

  } catch(e) { console.error(e); }
})();
})();
